export enum AmostrasPlacasScopesEnum {
  ComAmostrasAmostrasLogUsuariosPlaca = 'ComAmostrasAmostrasLogUsuariosPlaca',
}

export enum AmostrasPlacasEventsEnum {
  Removida = 'amostras-placas-removida',
  Criada = 'amostras-placas-criada',
  Criadas = 'amostras-placas-triagem-producao',
  Solicitadas = 'amostras-placas-solicitacao-producao',
  EntradasLab = 'amostras-placas-entrada-laboratorio-gru',
  IniciaCalcinacao = 'amostras-placas-calcinacao-inicio',
  FinalizaCalcinacao = 'amostras-placas-calcinacao-fim',
  EnvioLaboratorioGru = 'amostras-placas-envio-laboratorio-gru',
  RecebimentoLaboratorio = 'amostras-placas-recebimento-laboratorio',
}
